import 'regenerator-runtime/runtime';
import { put, call, takeEvery, all } from 'redux-saga/effects';
import { getActiveTenants, searchDashboard } from './api';

import * as IzendaActionType from './constants';
import * as NotifyActionType from '../Notification/constants';

export function* getActiveTenantsAsync(action) {
  const result = yield call(getActiveTenants);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: IzendaActionType.GET_ACTIVE_TENANTS_SUCCESS,
      data: result.data[0]
    });

    if (action.callback) {
      action.callback(result.data[0]);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchDashboardAsync(action) {
  const result = yield call(searchDashboard, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: IzendaActionType.SEARCH_DASHBOARD_SUCCESS,
      data: result.data
    });

    if (action.callback) {
      action.callback(result.data.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export default function* WatchIzenda() {
  yield all([
    takeEvery(IzendaActionType.GET_ACTIVE_TENANTS_ASYNC, getActiveTenantsAsync)
  ]);
  yield all([
    takeEvery(IzendaActionType.SEARCH_DASHBOARD_ASYNC, searchDashboardAsync)
  ]);
}



// WEBPACK FOOTER //
// ./src/izenda/saga.js